import { FormAtylBase } from '../../form-atyl-base';
/*
import { FormAtylService }                            from '../../form-atyl.service';
import { FormAtylControlService }                     from '../../form-atyl-control.service';
*/
export class AtylPlace extends FormAtylBase<string> {
  controlType = 'place';
  type: string;
  options: any[] = [];

  constructor(options: {} = {}) {
    super(options);
    this.type = options['type'] || [];
    this.options = options['options'] || [];
  }
}